

const defaultUsers = {};
const requests = (state = defaultUsers, action) => {
  switch (action.type) {
    case 'GET_USERS_REQUESTS_SUCCESS':
      return { ...action.users };
    case 'UPDATE_USER_REQUEST_SUCCESS':
      return { ...action.users };
    default:
      return state;
  }
};

export default requests;
